var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlararm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.00003,
    cy: 7.28544,
    r: 5.14286,
    stroke: "#667085"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5V7.09458C6 7.21399 6.05968 7.3255 6.15904 7.39174L7.71429 8.42857",
    stroke: "#667085",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85767 1L11.1434 2.71429",
    stroke: "#667085",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1L6 2.14286",
    stroke: "#667085",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85767 11.8574L9.42909 13.0003",
    stroke: "#667085",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14282 11.8574L2.57139 13.0003",
    stroke: "#667085",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14282 1L0.857108 2.71429",
    stroke: "#667085",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlararm);
export default __webpack_public_path__ + "static/media/alararm.8e6bc1b1e72a30c322e97af264bc6af9.svg";
export { ForwardRef as ReactComponent };